import React from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaUsers, FaBolt } from 'react-icons/fa';
import './Events.css';
import './Workshops.css';

const EventsWorkshops = () => {

  // ✅ Set to null if no current event, or fill in the object below
  const currentEvent = {
    title: 'DEMYSTIFYING STUDY ABROAD ',
    date: 'MAY 16, 2026',
    time: '6:30 PM IST',
    location: 'Online (Zoom)',
    description:
      'Join our expert counselors for an in-depth masterclass on navigating US university admissions — from building a standout profile to writing winning essays and understanding financial aid.',
    poster: '/events/demytifying1.jpeg',
    registerLink: '/register',
  };

  const pastEvents = [
    {
      title: 'DEMYSTIFYING STUDY ABROAD ',
      date: 'May 16, 2026',
      time: '6:30 PM IST',
      location: 'Online (Zoom)',
      poster: '/events/demytifying1.jpeg',
      attendees: '',
    },
    {
      title: 'DEMYSTIFYING STUDY ABROAD ',
      date: 'February 21, 2026',
      time: '5:00 PM IST',
      location: 'Online (Zoom)',
      poster: '/events/demystifyingstudy.jpeg',
      attendees: '',
    },
    {
      title: 'Boost your college profile with Research',
      date: 'September 20, 2025',
      time: '4:00 PM',
      location: 'Online',
      poster: '/eventbanner.jpg',
      attendees: '',
    },
    {
      title: 'How to make your college application work',
      date: '',
      time: '',
      location: 'Online',
      poster: '/eventbanner2.jpg',
      attendees: '',
    },
    {
      title: 'Demystifying Study Abroad after 12th',
      date: 'January 25, 2025',
      time: '4:00 PM',
      location: 'Online',
      poster: '/eventbanner3.jpg',
      attendees: '',
    },
    {
      title: 'How to make your college application work',
      date: 'July 21, 2025',
      time: '4:00 PM',
      location: 'Online',
      poster: '/eventbanner4.jpg',
      attendees: '',
    },
    {
      title: 'Demystifying Study Abroad after 12th',
      date: 'June 29, 2025',
      time: '6:30 PM',
      location: 'Online',
      poster: '/eventbanner5.jpg',
      attendees: '',
    },
    {
      title: 'Demystifying Study Abroad after 12th',
      date: 'July 14, 2025',
      time: '2:00 PM',
      location: 'Online',
      poster: '/eventbanner6.jpg',
      attendees: '',
    },
  ];

  return (
    <div className="events-page">

      {/* ── Hero Section ── */}
      <section className="events-hero section">
        <div className="container">
          <motion.div
            className="events-hero-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h1 className="section-title">Events & Workshops</h1>
            <p className="section-subtitle">
              Join us for educational events, workshops, and seminars designed to enhance your learning journey.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ── Current / Upcoming Event Section ── */}
      <section className="current-event section">
        <div className="container">
          {currentEvent ? (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {/* Section heading with live badge */}
              <div className="section-header" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '2rem' }}>
                <h2 className="section-title" style={{ margin: 0 }}>Upcoming Event</h2>
                <span className="live-badge">
                  <FaBolt style={{ marginRight: '4px' }} /> Live Soon
                </span>
              </div>

              {/* Event card */}
              <div className="current-event-card card">
                {/* Poster */}
                <div className="current-event-poster">
                  <img src={currentEvent.poster} alt={currentEvent.title} />
                  <div className="poster-overlay">
                    <span className="overlay-tag">Upcoming</span>
                  </div>
                </div>

                {/* Details */}
                <div className="current-event-details">
                  <h3 className="current-event-title">{currentEvent.title}</h3>
                  <p className="current-event-desc">{currentEvent.description}</p>

                  <div className="event-details" style={{ marginTop: '1.2rem' }}>
                    <div className="event-info">
                      <FaCalendarAlt /> <span>{currentEvent.date}</span>
                    </div>
                    <div className="event-info">
                      <FaClock /> <span>{currentEvent.time}</span>
                    </div>
                    <div className="event-info">
                      <FaMapMarkerAlt /> <span>{currentEvent.location}</span>
                    </div>
                    {currentEvent.attendees && (
                      <div className="event-info">
                        <FaUsers /> <span>{currentEvent.attendees}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          ) : (
            <motion.div
              className="no-upcoming"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">No Upcoming Events</h2>
              <p style={{ textAlign: 'center', color: '#666' }}>
                Check back soon or subscribe below to get notified.
              </p>
            </motion.div>
          )}
        </div>
      </section>

      {/* ── Past Events ── */}
      {/* No animation wrapper — render directly so cards are always visible */}
      <section className="past-events section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Past Events</h2>
          </div>

          <div className="past-events-grid">
            {pastEvents.map((evt, idx) => (
              <div key={idx} className="past-event-card card">
                <div className="poster-wrapper">
                  <img src={evt.poster} alt={evt.title} className="poster-img" />
                </div>
                <div className="past-event-content">
                  <h3 className="event-title">{evt.title}</h3>
                  <div className="event-details">
                    {evt.date && (
                      <div className="event-info">
                        <FaCalendarAlt /> <span>{evt.date}</span>
                      </div>
                    )}
                    {evt.time && (
                      <div className="event-info">
                        <FaClock /> <span>{evt.time}</span>
                      </div>
                    )}
                    <div className="event-info">
                      <FaMapMarkerAlt /> <span>{evt.location}</span>
                    </div>
                    {evt.attendees && (
                      <div className="event-info">
                        <FaUsers /> <span>{evt.attendees}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA Section ── */}
      <section className="cta section">
        <div className="container">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Stay Updated</h2>
            <p>Subscribe to our newsletter to receive updates about upcoming events and educational opportunities.</p>
            <a href="/newsletter" className="btn btn-primary">Subscribe</a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default EventsWorkshops;